import PropTypes from 'prop-types'
import React from 'react'

import { DataBus } from '@thebeansgroup/eventbus'
import ThirdPartyTracking from '@thebeansgroup/third_party_tracking'

import {
  getEmailFromUrlQuery,
  navigateToSignUpPage,
  navigateToResetPasswordPage,
  redirectToPassthroughUrl
} from '@src/authorisation/children/router/helpers'
import {
  safeGet,
  checkForPageErrors,
  getQueryParamsArray
} from '@src/authorisation/helpers'
import { THIRD_PARTY_TRACKING_CONFIG } from '@src/constants'
import Snowplow from '@src/snowplow'

import {
  LogInScreen,
  AccountNotRecognisedScreen,
  WrongPasswordScreen
} from './children'
import {
  getWrongPasswordUserProvidersState,
  canDisplayWrongPasswordScreen,
  canDisplayAccountNotRecognisedScreen
} from './helpers'

export class LogIn extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      wrongPasswordUserProviders: [],
      ssoAccountNotRecognised: ''
    }
    this.bindHandlers()
  }

  bindHandlers() {
    this.onLogIn = this.onLogIn.bind(this)
    this.onSignUpClick = this.onSignUpClick.bind(this)
    this.onResetPasswordClick = this.onResetPasswordClick.bind(this)
    this.onRequestError = this.onRequestError.bind(this)
    this.onEmailChange = this.onEmailChange.bind(this)
    this.onBackToLoginClick = this.onBackToLoginClick.bind(this)
    this.onWrongPassword = this.onWrongPassword.bind(this)
    this.onSSONotFound = this.onSSONotFound.bind(this)
  }

  componentDidMount() {
    Snowplow.trackPageView()
    ThirdPartyTracking.init(
      getEmailFromUrlQuery(this.props),
      THIRD_PARTY_TRACKING_CONFIG
    )
    ThirdPartyTracking.pageView()
    checkForPageErrors(this.props.data)
  }

  onWrongPassword(data) {
    this.setState({
      wrongPasswordUserProviders: getWrongPasswordUserProvidersState(data)
    })
  }

  onBackToLoginClick() {
    this.setState({
      wrongPasswordUserProviders: [],
      ssoAccountNotRecognised: ''
    })
  }

  onEmailChange(value) {
    this.setState({ email: value })
  }

  onRequestError(data) {
    this.props.data.errorHandler(data)
  }

  onSSONotFound(ssoAccount) {
    this.setState({ ssoAccountNotRecognised: ssoAccount })
  }

  handleRedirect() {
    redirectToPassthroughUrl(this.props)
  }

  handleLogInCallback(data) {
    DataBus.emit('authorisation.log-in', {
      firstName: safeGet(['user', 'profile', 'first_name'], data),
      lastName: safeGet(['user', 'profile', 'last_name'], data)
    })
    this.handleRedirect()
  }

  onLogIn(data) {
    this.props.data.valueChangeHandler(
      {
        token: safeGet(['authenticity_token'], data),
        email: safeGet(['user', 'email'], data),
        id: safeGet(['user', 'id'], data),
        first_name: safeGet(['user', 'profile', 'first_name'], data),
        last_name: safeGet(['user', 'profile', 'last_name'], data),
        date_of_birth: safeGet(['user', 'profile', 'date_of_birth'], data),
        gender: safeGet(['user', 'profile', 'gender'], data)
      },
      this.handleLogInCallback.bind(this, data)
    )
  }

  onSignUpClick() {
    navigateToSignUpPage(this.props, getQueryParamsArray())
  }

  onResetPasswordClick() {
    navigateToResetPasswordPage(this.props)
  }

  renderLogInScreen() {
    return (
      <LogInScreen
        token={this.props.data.token}
        user={this.props.data.user}
        email={this.state.email}
        logInHandler={this.onLogIn}
        signUpClickHandler={this.onSignUpClick}
        requestErrorHandler={this.onRequestError}
        emailValueChangeHandler={this.onEmailChange}
        resetPasswordClickHandler={this.onResetPasswordClick}
        wrongPasswordHandler={this.onWrongPassword}
        ssoNotFoundHandler={this.onSSONotFound}
        country={this.props.params.country}
        consumerGroup={this.props.data.consumerGroup}
        medium={this.props.data.medium}
        offer={this.props.data.offer}
      />
    )
  }

  renderWrongPasswordScreen() {
    return (
      <WrongPasswordScreen
        token={this.props.data.token}
        email={this.state.email}
        userProviders={this.state.wrongPasswordUserProviders}
        logInHandler={this.onLogIn}
        requestErrorHandler={this.onRequestError}
        resetPasswordClickHandler={this.onResetPasswordClick}
        backToLoginClickHandler={this.onBackToLoginClick}
        ssoNotFoundHandler={this.onSSONotFound}
      />
    )
  }

  renderAccountNotRecognisedScreen() {
    return (
      <AccountNotRecognisedScreen
        account={this.state.ssoAccountNotRecognised}
        backToLoginClickHandler={this.onBackToLoginClick}
        signUpClickHandler={this.onSignUpClick}
      />
    )
  }

  renderContent() {
    if (canDisplayAccountNotRecognisedScreen(this.state)) {
      return this.renderAccountNotRecognisedScreen()
    } else if (canDisplayWrongPasswordScreen(this.state)) {
      return this.renderWrongPasswordScreen()
    }

    return <>{this.renderLogInScreen()}</>
  }

  render() {
    return <>{this.renderContent()}</>
  }
}

LogIn.propTypes = {
  data: PropTypes.shape({
    user: PropTypes.object.isRequired,
    error: PropTypes.string,
    token: PropTypes.string.isRequired,
    errorHandler: PropTypes.func.isRequired,
    valueChangeHandler: PropTypes.func.isRequired,
    consumerGroup: PropTypes.string.isRequired,
    offer: PropTypes.shape({
      title: PropTypes.string.isRequired,
      logo: PropTypes.string.isRequired
    }).isRequired
  })
}

export default LogIn
